import React from 'react';
import useIntl from '../useIntl';
/**
 * React component to format a number
 */
export function FormattedNumber(props) {
    var formatNumber = useIntl().formatNumber;
    return React.createElement(React.Fragment, null, formatNumber(props));
}
